import { observer } from "mobx-react";
import { Modal } from "react-bootstrap";
import { IModal } from "../../stores";
import { useEffect, useState } from "react";
import { ShowAlert } from "../../utils/functions";
import { useStores } from "../../stores/root-store";

const ForgotPasswordPage = observer(({ show, setShowModal }: IModal) => {
  const { authStore } = useStores();
  const { forgotPassword } = authStore;

  const [email, setEmail] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    setIsFormValid(email ? true : false);
  }, [email]);

  const submitCallback = (res: boolean, token: string) => {
    if (res && token) {
      setShowModal(false);
      ShowAlert.Info(
        "Password reset email sent to your registered email address. Please check your email."
      );
    } else ShowAlert.Error("Request failed. Please try agin.");
  };

  const handleFormSubmit = () => {
    if (!isFormValid) ShowAlert.Error("Please enter registered email.");
    else {
      var pwdResetUrl = btoa(window.location.origin + "/reset-pwd");
      forgotPassword(email, pwdResetUrl, submitCallback);
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => setShowModal(false)}
      centered
      scrollable
      dialogClassName="modal-sm"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h4>Forgot Password</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className="row">
            <div className="col-sm-12">
              <div className="panel panel-default">
                <div className="panel-body">
                  <form autoComplete="off">
                    <div className="form-floating mb-3">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <label htmlFor="email">Email address</label>
                    </div>

                    <div className="btn-group d-flex mt-3">
                      <button
                        onClick={handleFormSubmit}
                        className="btn btn-default rounded-0 flex-fill"
                        disabled={!isFormValid}
                        type="button"
                      >
                        Send Reset Password Link
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
});

export default ForgotPasswordPage;
